<template>
	<main id="main" class="main">
		<section class="lists">
			<div class="inner">
				<div class="cats tabcontent">
				<a
					v-for="(article, index) in articleData"
					:key="`${tabList[tabActive]}-${index}`"
					class="item"
					:href="article.link"
					target="_blank"
					rel="noreferrer noopener"
					@click="sendAnalytic('網友文章', article.title, tabList[tabActive])"
				>
					<div class="img">
					<img :src="article.image" />
					</div>
					<div class="description">
					<p>{{ article.title }}</p>
					</div>
				</a>
				</div>
			</div>
			<div
				class="hamburger d-none"
				@click="sideMenuActive = !sideMenuActive"
			>
			</div>
			<!-- 手機版menu -->
			<div
				class="side_menu"
				:class="{ 'active': sideMenuActive }"
			>
				<div class="top">
					<div
						class="close"
						@click="sideMenuActive = !sideMenuActive"
					>
						<img src="@/assets/close.svg" />
					</div>
				</div>
				<div
					v-for="(tab, index) in tabList"
					:key="`tab-mb-${index}`"
					:class="{'active': tabActive === index}"
					class="tablink Sheet1_Click"
					@click="clickTablink(index)"
				>
					{{ tab }}
				</div>
			</div>
		</section>
		<!-- 看更多文章 -->
		<section class="more-article">
			<button class="btn-more js-more-article Content_more_click"
					v-show="pageOption.page < pageOption.pageTotal"
					@click="getMoreArticleData()">看更多文章</button>
		</section>
	</main>
</template>

<script setup>
import { ref, reactive } from 'vue';
import sendAnalytic from '@/common/sendAnalytic';
import articleMap from '@/data/articles';

const tabList = ['舒特膚'];
const tabActive = ref(0);
const sideMenuActive = ref(false);
const articleData = ref([]);
const defaultPageSize = 9;

/** 頁數控制
 * @param {number} page 當前頁數
 * @param {number} pageSize 一頁幾筆資料
 */
const pageOption = reactive({
	page: 1,
	pageTotal: 1
})

const clickTablink = id => {
	tabActive.value = id;
	getArticleData();
}

const getCurrentArticles = () => articleMap[tabList[tabActive.value]] || [];

/** 取得文章
 * @param {number} pageSize 一頁幾筆資料
 * @param {number} page 當前頁數
 */
const getArticleData = ( page = 1, pageSize = defaultPageSize ) => {
	const articles = getCurrentArticles();
	const currentArticles = articles.slice(0, page * pageSize);

	pageOption.page = page;
	articleData.value = currentArticles;
	pageOption.pageTotal = Math.max(1, Math.ceil(articles.length / pageSize));
};

const getMoreArticleData = () => {
	pageOption.page++;
	getArticleData(pageOption.page);
	sendAnalytic('功能按鈕', '看更多文章');
}

getArticleData();

</script>
